angular.module('bmsApp.directives').factory('ActivityTypeSvc', [
    'CRUDSvc',
    'ACTIVITY_TYPE_API', function (
        CRUDSvc,
        ACTIVITY_TYPE_API) {

        return {
            index: function () {
                return CRUDSvc.get(ACTIVITY_TYPE_API.INDEX);
            }
        };

    }])
.constant('ACTIVITY_TYPE_API', {
    INDEX: 'api/activityTypes'
});
